import type { IconData } from '@stacksjs/iconify-core'

export const toiletSignManSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 15a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m-5.975 1.717c1.383-.115 3.347-.217 5.976-.217s4.592.101 5.975.217c1.82.151 3.317 1.355 3.89 3.08a54.8 54.8 0 0 1 2.386 10.785c.217 1.888-1.202 3.518-3.08 3.636c-.547.034-1.164.07-1.842.103l-.657 8.866c-.119 1.605-1.325 2.945-2.96 3.11c-.3.03-.622.06-.957.086a1.48 1.48 0 0 1-1.591-1.422l-.374-8.982a.5.5 0 0 0-.5-.479h-.582a.5.5 0 0 0-.5.48l-.373 8.981a1.48 1.48 0 0 1-1.591 1.422a44 44 0 0 1-.958-.087c-1.634-.164-2.84-1.504-2.96-3.11l-.656-8.865q-1.019-.051-1.843-.103c-1.878-.118-3.297-1.748-3.08-3.636a54.8 54.8 0 0 1 2.386-10.784c.573-1.726 2.07-2.93 3.89-3.081Z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletSignManSolid
